export { positionElements, Positioning } from './ng-positioning'
export { PositioningService, PositioningOptions } from './positioning.service';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
